/* eslint-disable react/require-default-props */
import { Button } from '@mui/material';
import { useState } from 'react';

import { IconAttachFileMS } from '../../../../../../constants/icons';
import {
  isRichTextEmpty,
  RichTextEditor,
} from '../../../../../Announcements/components/RichTextEditor';
import {
  DialogActionsBox,
  DialogContainer,
  DialogTitleTypography,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../styles';

interface RejectDialogProps {
  docId?: number;
  name: string;
  document: string;
  docLoading: boolean;
  disabled: boolean;
  handleReject: (reason: string, docId?: number) => Promise<void>;
  disapprove?: boolean;
}

export function RejectDialog({
  docId,
  name,
  document,
  docLoading,
  disabled,
  handleReject,
  disapprove = false,
}: RejectDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const isEmpty = isRichTextEmpty(reason);

  const handleConfirm = (): void => {
    handleReject(reason, docId).then(() => {
      // O motivo vive neste componente, que NÃO desmonta com o diálogo: sem
      // limpar, a próxima rejeição do mesmo documento abriria com o texto
      // anterior preenchido, parecendo rascunho salvo.
      //
      // Limpa em qualquer desfecho porque `handleReject` não informa o
      // resultado: `withDocLoading` (LicenseRequest/index.tsx) captura o erro,
      // mostra o snackbar e resolve — e o diálogo já fechava nos dois casos.
      // Para preservar o texto quando falha (como o composer de comentários
      // faz), o handler precisaria devolver sucesso/erro.
      setReason('');
      handleClose();
    });
  };

  return (
    <>
      <OutlinedButton
        sx={{ maxWidth: disapprove ? '260px' : '120px' }}
        onClick={handleOpen}
        disabled={disabled}
      >
        {disapprove ? 'desaprovar' : 'rejeitar'}
      </OutlinedButton>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <DialogTitleTypography>
            {disapprove ? 'Desaprovar' : 'Rejeitar'} {name}
          </DialogTitleTypography>
          <TextTypography sx={{ justifyContent: 'center' }}>
            {IconAttachFileMS}
            {document}
          </TextTypography>
          <RichTextEditor
            value={reason}
            onChange={setReason}
            placeholder="Explique o motivo da rejeição"
            charLimit={3000}
          />
          <DialogActionsBox my={2.5}>
            <OutlinedButton
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleClose}
            >
              cancelar
            </OutlinedButton>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={docLoading || isEmpty}
              onClick={handleConfirm}
            >
              {disapprove ? 'desaprovar' : 'rejeitar'}
            </Button>
          </DialogActionsBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
